var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.414L14.414 0H33.182C31.189 0.964 29.34 2.246 27.728 3.858L4.063 27.523C1.432 24.316 0 20.333 0 16.13V16V14.414ZM16 58H14.414L0 43.586V24.818C0.964 26.812 2.246 28.66 3.858 30.273L27.523 53.938C24.316 56.569 20.333 58 16.13 58H16ZM58 43.586L43.586 58H24.818C26.811 57.036 28.66 55.754 30.272 54.142L53.937 30.477C56.568 33.684 58 37.667 58 41.87V42V43.586ZM54.142 27.728L30.477 4.063C33.684 1.431 37.667 0 41.87 0H42H43.586L58 14.414V33.182C57.036 31.188 55.754 29.34 54.142 27.728Z",
    fill: "#F15845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.a959dbc4d6bb202b7abb49b078b42bb7.svg";
export { ForwardRef as ReactComponent };